(function(){
function ready(f){if(document.readyState!=='loading')f();else document.addEventListener('DOMContentLoaded',f)}
ready(function(){
/* ---- recipe article: turn the pasted recipe into two columns ---- */
var box=document.querySelector('.rb-content');
if(box){
 var lede=document.querySelector('.rhero .lede'),ledeText=lede?lede.textContent.trim():'';
 var kids=Array.prototype.slice.call(box.children),left=document.createElement('div'),right=document.createElement('div'),disc=document.createElement('p');
 var seenH2=0,where=null;
 kids.forEach(function(el){
  var tag=el.tagName,txt=el.textContent.trim();
  if(tag==='P'&&seenH2===0&&(el.children.length===1&&el.children[0].tagName==='EM'||txt===ledeText)){return}
  if(tag==='H2'){seenH2++}
  if(tag==='P'&&/^where i get/i.test(txt)){where=document.createElement('div');where.className='where';where.appendChild(el);return}
  if(tag==='P'&&/not medical advice/i.test(txt)){disc.className='discl';disc.innerHTML=el.innerHTML;return}
  if(seenH2===1)left.appendChild(el);else right.appendChild(el);
 });
 var ul=left.querySelector('ul');
 if(ul){ul.className='ing';Array.prototype.forEach.call(ul.children,function(li){li.innerHTML='<label><input type="checkbox"><span>'+li.innerHTML+'</span></label>'})}
 if(where)left.appendChild(where);
 var cols=document.createElement('div');cols.className='cols';cols.id='make';cols.appendChild(left);cols.appendChild(right);
 box.innerHTML='';box.appendChild(cols);if(disc.innerHTML)box.appendChild(disc);
}
/* ---- coming-soon form: tags ---- */
document.querySelectorAll('form.soonform').forEach(function(f){
 var t=f.querySelector('input[name="contact[tags]"]'),c=f.querySelector('input.wantrecipes');
 function set(){t.value=c&&c.checked?'newsletter,coming-soon,recipes':'newsletter,coming-soon'}
 if(c)c.addEventListener('change',set);set();
});
/* ---- product page: variants + gallery ---- */
var pf=document.getElementById('productform');
if(pf){
 var variants=JSON.parse(document.getElementById('variants-json').textContent);
 var idInput=pf.querySelector('input[name="id"]'),btn=pf.querySelector('.buy'),price=document.getElementById('pprice');
 function pick(){
  var chosen=[];pf.querySelectorAll('.optgroup').forEach(function(g,i){var r=g.querySelector('input:checked');chosen[i]=r?r.value:null;var l=g.querySelector('.cur');if(l)l.textContent=chosen[i]||''});
  var v=variants.filter(function(x){return x.options.every(function(o,i){return o===chosen[i]})})[0];
  if(v){idInput.value=v.id;price.textContent=v.price_formatted;btn.disabled=!v.available;btn.textContent=v.available?'Add to cart':'Sold out'}
  else{btn.disabled=true;btn.textContent='Unavailable'}
 }
 pf.addEventListener('change',pick);pick();
 var main=document.getElementById('mainimg');
 document.querySelectorAll('.thumbs button').forEach(function(b){b.addEventListener('click',function(){main.src=b.getAttribute('data-src');document.querySelectorAll('.thumbs button').forEach(function(x){x.setAttribute('aria-pressed',x===b)})})});
}
});
})();
